// src/components/OutlookMail/OutlookMailResult.tsx
// Compact success toast/card for sent emails and saved drafts

import * as React from "react";
import { OutlookMailResult as OutlookMailResultType } from "../../interfaces/outlookMailTypes";
import { Check, FileText } from "lucide-react";
import OutlookLogo from "../../../assets/Outlook_Logo.svg";
import {
  outlookColors,
  resultCardStyle,
  resultIconStyle,
  resultLabelStyle,
  resultSubjectStyle,
  resultMetaStyle,
} from "./outlookMailStyles";

interface OutlookMailResultProps {
  result: OutlookMailResultType;
}

const OutlookMailResult: React.FC<OutlookMailResultProps> = ({ result }) => {
  const isSent = result.action === "send";

  const recipientDisplay = result.toRecipients
    .map((r) => {
      // If it looks like an email, show just the local part
      const atIdx = r.indexOf("@");
      return atIdx > 0 ? r.substring(0, atIdx) : r;
    })
    .join(", ");

  return (
    <div style={resultCardStyle(isSent)}>
      {/* Status Icon */}
      {isSent ? (
        <div style={resultIconStyle(true)}>
          <Check size={16} color={outlookColors.successGreen} />
        </div>
      ) : (
        <OutlookLogo style={{ width: 24, height: 24, flexShrink: 0, overflow: "visible" }} />
      )}

      {/* Content */}
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={resultLabelStyle(isSent)}>{isSent ? "Email Sent" : "Saved as Draft"}</span>
        </div>

        <p style={resultSubjectStyle}>{result.subject}</p>

        <div style={resultMetaStyle}>
          <span>To: {recipientDisplay}</span>
          {result.hasAttachment && result.attachmentName && (
            <>
              <span style={{ color: outlookColors.borderDivider }}>&#x2022;</span>
              <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <FileText size={12} />
                {result.attachmentName}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OutlookMailResult;
